var render = function render() {
  var _vm = this,
      _c = _vm._self._c;return _c('div', { staticClass: "previewer-switcher custom-scroll-bar" }, [_c('ul', _vm._l(_vm.list, function (item) {
    return _c('li', { key: item.id, class: { active: _vm.currentId === item.id }, on: { "click": function click($event) {
          return _vm.handleClick(item.id);
        } } }, [_c('div', [_c('el-tooltip', { attrs: { "disabled": !item.tips || !item.tips.length, "placement": "top", "effect": "dark" } }, [_c('ul', { staticClass: "tips-desc", attrs: { "slot": "content" }, slot: "content" }, _vm._l(item.tips, function (info, index) {
      return _c('li', { key: index }, [_c('span', { staticClass: "label" }, [_vm._v(_vm._s(info.label) + "：")]), _vm._v(_vm._s(info.name))]);
    }), 0), _vm._v(" "), _c('span', [_vm._v(_vm._s(item.label || item.name))])])], 1)]);
  }), 0)]);
};
var staticRenderFns = [];

export { render, staticRenderFns };